<template>
  <div class="section-title-block">
    <h2 class="section-title">
      {{ props.title }}
    </h2>

    <template v-if="props.showMoreButton">
      <a
        v-if="props.href"
        class="show-more"
        :href="props.href"
      >
        {{ props.showMore }}
      </a>

      <router-link
        v-else-if="props.to"
        class="show-more"
        :to="props.to"
      >
        {{ props.showMore }}
      </router-link>
    </template>
  </div>
</template>

<script setup lang="ts">
  import type { RouterLinkProps } from 'vue-router';

  const props = withDefaults(
    defineProps<{
      title: string;
      showMore: string;

      showMoreButton?: boolean;
      to?: RouterLinkProps['to'];
      href?: string;
    }>(),
    {},
  );
</script>

<style lang="scss" scoped>
  @use '@experience/design-tokens/typography' as typography;
  @use '@experience/shared/dist/assets/adaptivity' as adaptivity;

  .section-title-block {
    display: flex;
    align-items: baseline;
  }

  .section-title {
    margin-bottom: 24px;

    @include typography.base-800-750-extra;

    @include adaptivity.mobile {
      margin-bottom: 16px;

      @include typography.base-700-500-extra;
    }
  }

  .show-more {
    margin-left: 24px;
    color: var(--alias-color-link-default);
    text-decoration: none;
    white-space: nowrap;

    @include typography.base-400-400-regular;

    &:hover {
      opacity: 0.8;
    }

    @include adaptivity.tablet {
      display: none;
    }
  }
</style>
